import React from 'react';

// helpers
import styled from 'styled-components';
import { StateModel } from '../../redux/reducers';
import { useSelector } from 'react-redux';
import { StateModel as AuthStateModel } from '../../redux/reducers/auth';
import { USER_TAG_IS_SKIPPED_VERIFICATION_EMAIL } from 'constants/userTags';

// components
import VerifyEmail from '../../modules/Auth/VerifyEmail';

const VerificationPage = () => {
  const { verificationStatuses, profileData } = useSelector<
    StateModel,
    AuthStateModel
  >((store) => store.auth);

  const renderContent = () => {
    const { isEmailVerified } = verificationStatuses;

    if (
      !isEmailVerified &&
      !profileData?.tags.includes(USER_TAG_IS_SKIPPED_VERIFICATION_EMAIL)
    ) {
      return <VerifyEmail />;
    }
  };

  return <Wrapper>{renderContent()}</Wrapper>;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default VerificationPage;
